export default {
    namespaced: true,
    state: {
        enabled: false,
        model: '',
    },
    getters: {
        isEnabled: state => state.enabled,
        activeModel: state => state.model
    },
    mutations: {
        setStatus (state, value) {
            state.enabled = value;
        },
        setModel (state, name) {
            state.model = name;
        }
    }
}